import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment, useQuery } from "@opensea/graphql";
import { Flex } from "@opensea/ui-kit";
import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";
import { Button } from "../../../../components/Button";
import { TransactionFullScreen } from "../../../../components/TransactionFullScreen";
import { TransactionReceipt, TransactionReceiptCollectionFragment } from "../../../../components/TransactionReceipt";
import { TransactionReceiptFragment } from "../../../../components/TransactionReceipt/TransactionReceipt.fragment";
import { ViewItemsOnProfileButton } from "../../../../components/ViewItemsOnProfileButton";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../../constants";
import { FlowActions } from "../../../../stores/flowStore";
import { useSetReceiptStatusFragment } from "../../../hooks/useSetReceiptStatus";
const FETCH_INTERVAL = 500;
const receiptQuery = graphql(`
    query MintFlowStatusQuery(
      $transactionIdentifiers: [TransactionIdentifier!]!
      $itemQuotes: [ItemQuoteInput!]!
      $swapProvider: SwapProviderType!
    ) {
      buyReceipt(
        transactionIdentifiers: $transactionIdentifiers
        itemQuotes: $itemQuotes
        swapProvider: $swapProvider
        action: MINT
      ) {
        status
        itemReceipts {
          __typename
          item {
            id
            imageUrl
          }
        }
        failedItemReceipts {
          __typename
        }
        ...useSetReceiptStatus
        ...TransactionReceipt
      }
    }
  `, [TransactionReceiptFragment, useSetReceiptStatusFragment]);
export const MintStatusCollectionFragment = graphql(`
    fragment MintStatusCollection on Collection {
      imageUrl
      ...TransactionReceiptCollection
    }
  `, [TransactionReceiptCollectionFragment]);
export function MintStatus(t0) {
  const $ = _c(40);
  const {
    collection: collectionKey,
    transactionIdentifier,
    tokenInputs,
    isCrossChain,
    itemQuotes,
    walletDestination
  } = t0;
  const t = useTranslations("wallet.MintStatus");
  const collection = readFragment(MintStatusCollectionFragment, collectionKey);
  const [receiptOpen, setReceiptOpen] = useState(false);
  let t1;
  if ($[0] !== transactionIdentifier.chain || $[1] !== transactionIdentifier.transactionHash) {
    t1 = [{
      chain: transactionIdentifier.chain,
      transactionHash: transactionIdentifier.transactionHash
    }];
    $[0] = transactionIdentifier.chain;
    $[1] = transactionIdentifier.transactionHash;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isCrossChain ? "RELAY" : "LOCAL_MINT_NFT";
  let t3;
  if ($[3] !== itemQuotes || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      query: receiptQuery,
      variables: {
        transactionIdentifiers: t1,
        itemQuotes,
        swapProvider: t2
      },
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[3] = itemQuotes;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const [t4, reexecuteQuery] = useQuery(t3);
  const {
    data,
    fetching
  } = t4;
  const isPending = !data || data.buyReceipt.status === "PENDING";
  let t5;
  if ($[7] !== data?.buyReceipt.itemReceipts) {
    t5 = data?.buyReceipt.itemReceipts.every(_temp);
    $[7] = data?.buyReceipt.itemReceipts;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const allItemsLoaded = t5;
  let t6;
  let t7;
  if ($[9] !== allItemsLoaded || $[10] !== fetching || $[11] !== isPending || $[12] !== reexecuteQuery) {
    t6 = function pollForReceipt() {
      if ((isPending || !allItemsLoaded) && !fetching) {
        const timerId = setTimeout(() => {
          reexecuteQuery({
            requestPolicy: "network-only"
          });
        }, FETCH_INTERVAL);
        return () => clearTimeout(timerId);
      }
    };
    t7 = [allItemsLoaded, fetching, isPending, reexecuteQuery];
    $[9] = allItemsLoaded;
    $[10] = fetching;
    $[11] = isPending;
    $[12] = reexecuteQuery;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== data?.buyReceipt.status) {
    t8 = function handleSuccess() {
      if (data?.buyReceipt.status === "SUCCESS") {
        FlowActions.onSuccess();
      }
    };
    $[15] = data?.buyReceipt.status;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = data?.buyReceipt.status;
  let t10;
  if ($[17] !== t9) {
    t10 = [t9];
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  useEffect(t8, t10);
  if (isPending) {
    let t11;
    if ($[19] !== t) {
      t11 = t("pending.description");
      $[19] = t;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    const t12 = tokenInputs.flatMap(item => new Array(item.quantity).fill(collection.imageUrl));
    let t13;
    if ($[21] !== t) {
      t13 = t("pending.title");
      $[21] = t;
      $[22] = t13;
    } else {
      t13 = $[22];
    }
    return <TransactionFullScreen body={t11} images={t12} loading={true} title={t13} />;
  }
  if (data.buyReceipt.status === "FAILED") {
    let t11;
    if ($[23] !== t) {
      t11 = t("failed.description");
      $[23] = t;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    const t12 = tokenInputs.flatMap(item_0 => new Array(item_0.quantity).fill(collection.imageUrl));
    let t13;
    if ($[25] !== t) {
      t13 = t("failed.title");
      $[25] = t;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    return <TransactionFullScreen body={t11} images={t12} monochrome={true} title={t13} />;
  }
  const images = data.buyReceipt.itemReceipts.map(itemReceipt_0 => itemReceipt_0.item?.imageUrl ?? collection.imageUrl);
  let t11;
  if ($[27] !== collection || $[28] !== data.buyReceipt || $[29] !== receiptOpen || $[30] !== setReceiptOpen || $[31] !== t || $[32] !== walletDestination) {
    t11 = receiptOpen ? <TransactionReceipt collection={collection} flowType="mint" receipt={data.buyReceipt} walletDestination={walletDestination} /> : <Flex className="gap-4"><Button onClick={() => setReceiptOpen(true)} variant="secondary">{t("viewReceipt")}</Button><ViewItemsOnProfileButton itemIds={data.buyReceipt.itemReceipts.flatMap(_temp2)} walletDestinationAddress={walletDestination?.address} /></Flex>;
    $[27] = collection;
    $[28] = data.buyReceipt;
    $[29] = receiptOpen;
    $[30] = setReceiptOpen;
    $[31] = t;
    $[32] = walletDestination;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t) {
    t12 = t("success.title");
    $[34] = t;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== images || $[37] !== t11 || $[38] !== t12) {
    t13 = <TransactionFullScreen bottom={t11} confetti={true} images={images} title={t12} />;
    $[36] = images;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  return t13;
}
function _temp2(itemReceipt_1) {
  return itemReceipt_1.item ? [itemReceipt_1.item.id] : [];
}
function _temp(itemReceipt) {
  return Boolean(itemReceipt.item);
}